import { ScopesGql } from '@papi/interfaces'

export const scopeFields: (keyof ScopesGql)[] = [
  'bookingcosts',
  'bookingfees',
  'bookingformulas',
  'calendars',
  'channelAdjustments',
  'charges',
  'checkins',
  'customCodes',
  'dataFeeds',
  'discounts',
  'expenses',
  'extras',
  'groupRates',
  'guests',
  'guestsCreate',
  'images',
  'incidents',
  'inquiries',
  'inquiriesCancel',
  'inquiriesCreate',
  'inventories',
  'invoices',
  'messages',
  'messagesEmail',
  'preferences',
  'rates',
  'rentals',
  'rentalsAccess',
  'rentalsCreate',
  'reviews',
  'rooms',
  'shares',
  'smartdevices',
  'tags',
  'tasks',
  'templates',
  'triggers',
  'users',
]
